import { __rest } from "tslib";
import * as React from 'react';
const ChevronDownXLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 60 60", fill: "currentColor", width: size || "60", height: size || "60" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M53.7061298,17.6633709 L54.4132366,18.3704777 L31.0826291,41.7033709 L31.0853664,41.7061298 L30.3782597,42.4132366 L30.3756291,42.4103709 L30.3749329,42.4121082 L29.6678261,41.7050015 L29.6686291,41.7033709 L6.3366291,18.3716061 L7.04373588,17.6644993 L30.3756291,40.9963709 L53.7061298,17.6633709 Z" })));
};
ChevronDownXLarge.displayName = 'ChevronDownXLarge';
export default ChevronDownXLarge;
//# sourceMappingURL=ChevronDownXLarge.js.map